import type { HttpClient } from './HttpClient';
import type { ISearchWireResult } from './ISearchWireResult';

/** Стеля збігів для сервера попереднього формату (limit — загальна кількість, найбільше 200). */
const LEGACY_LIMIT = 200;

/**
 * Глобальний пошук записів у воркспейсі або в усіх доступних: perGroup — збігів у групі (новий формат; лічильник групи повний), limit — для
 * сервера попереднього формату, який групи не обрізає, а обмежує загальну кількість; groupBy — групи за модулем (типово) чи типом запису.
 */
export class SearchDao {
  constructor(private readonly http: HttpClient) {}
  search(q: string, workspaceId?: string, perGroup = 20, groupBy?: 'module' | 'recordType'): Promise<ISearchWireResult> {
    return this.http.get('/search', { q, workspaceId, perGroup, limit: LEGACY_LIMIT, groupBy });
  }
}
